import React from 'react'
import { inject, observer } from 'mobx-react'
import MarkersWithinList from './MarkersWithinList'
import { withTranslation } from 'react-i18next'

// This container is always rendered, but renders e.g. a chart,
// an error, or nothing depending on the state of the selection
const MarkersWithinPane = ({ selectionStore, t }) => selectionStore.item.analysis.loadingMarkers
  ? (
    <div className='analysis loading loading-dark markers-within-loader'>
      <div className='message-container'>
        <p>{t('GLOBAL.ANALYSING_MARKERS_WITHIN')}</p>
      </div>
      <section className='analysis-tall'>
        <div className='analysis-contents'>
          <div className='analysis-column' />
        </div>
      </section>
    </div>
    )
  : (
    <MarkersWithinList
      markers={selectionStore.item.analysis.markersList}
      selectedMarkerId={selectionStore.item.analysis.selectedMarkerId}
    />
    )

export default withTranslation()(inject('selectionStore')(observer(MarkersWithinPane)))
